const TestimonialLogo=[
    {
        id: 1,
        src: require('../assets/Investocity.png'),
        alt : "Image",
    },
    {
        id: 2,
        src: require('../assets/HikingBody.png'),
        alt : "Image",
    },
    {
        id: 3,
        src: require('../assets/Seedling.png'),
        alt : "Image",
    },
    {
        id: 4,
        src: require('../assets/RipenApps.png'),
        alt : "Image",
    },
    {
        id: 5,
        src: require('../assets/JustBook.png'),
        alt : "Image",
    },
    {
        id: 6,
        src: require('../assets/Vertax.png'),
        alt : "Image",
    },
    {
        id: 7,
        src: require('../assets/Realtor.png'),
        alt : "Image",
    },
    {
        id: 8,
        src: require('../assets/Vowels.png'),
        alt : "Image",
    },
    {
        id: 9,
        src: require('../assets/Taxi.jpg'),
        alt : "Image",
    },
    {
        id: 10,
        src: require('../assets/InGraphics.png'),
        alt : "Image",
    },
    {
        id: 11,
        src: require('../assets/Advanda.jpg'),
        alt : "Image",
    },
    {
        id: 12,
        src: require('../assets/Simi.png'),
        alt : "Image",
    },
]


export default TestimonialLogo;